module.exports = __webpack_public_path__ + "img/close-green.76725778.svg";